import React from 'react';
import { connect } from 'react-redux';

import Fallback from '@common-components/session/Fallback';
import SsapDuplicationFallback from '@common-components/session/SsapDuplicationFallback';

import { history } from '@store/appStore';


const FallbackContainer = props => {

    const {
        environment: {
            links: {
                LOGOUT: logout
            },
            stateCode
        }
    } = props;

    const isSsapDuplication = history?.location?.state?.isSsapDuplication ?? false;

    const getFallback = () => {
        switch(true) {
            case isSsapDuplication === true:
                return <SsapDuplicationFallback stateCode = { stateCode } />;
            default:
                return <Fallback { ...{ logout, stateCode } }/>;
        }
    };

    return getFallback();
};


const mapStateToProps = state => ({
    environment: state.common.environment
});
export default connect(mapStateToProps)(FallbackContainer);